export const IMAGE_URL =
  'https://res.cloudinary.com/ds2lfhjuk/image/upload/v1644134006'
export const AUDIO_URL =
  'https://res.cloudinary.com/ds2lfhjuk/video/upload/v1644134006'
export const GROUP_COLOR = [
  {
    color: { backgroundColor: '#8b0061' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #8b0061)` },
  },
  {
    color: { backgroundColor: '#1b73ba' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #1b73ba)` },
  },
  {
    color: { backgroundColor: '#f8d23c' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #f8d23c)` },
  },
  {
    color: { backgroundColor: '#ff534d' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #ff534d)` },
  },
  {
    color: { backgroundColor: '#de8a00' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #de8a00)` },
  },
  {
    color: { backgroundColor: '#7478ae' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #7478ae)` },
  },
  {
    color: { backgroundColor: '#000' },
    gradient: { backgroundImage: `linear-gradient(rgba(0,0,0,0), #000)` },
  },
]
